<script lang="ts" module>
	import type { Snippet } from 'svelte';
	import type { ClassValue, SvelteHTMLElements } from 'svelte/elements';
	import type { VariantProps } from 'tailwind-variants';
	import { tv } from '../tv';
	import { RADII_VARIANTS } from '../variants';

	export const avatarVariants = tv({
		base: 'relative inline-flex shrink-0 items-center justify-center overflow-hidden select-none focus-outline disabled-state',
		variants: {
			size: {
				'200': 'size-[1.5rem]',
				'300': 'size-[2.25rem]',
				'400': 'size-[2.625rem]',
				'500': 'size-[3.625rem]'
			},
			radii: RADII_VARIANTS
		},
		defaultVariants: { size: '400', radii: '400' }
	});

	export type AvatarProps<T extends keyof SvelteHTMLElements = 'span'> = Omit<
		SvelteHTMLElements[T],
		'class'
	> &
		VariantProps<typeof avatarVariants> & {
			as?: T;
			children?: Snippet;
			class?: ClassValue;
			ref?: HTMLElement | null;
		};
</script>

<script lang="ts" generics="T extends keyof SvelteHTMLElements = 'span'">
	let {
		as = 'span' as T,
		children,
		class: className,
		radii,
		ref = $bindable(null),
		size,
		...rest
	}: AvatarProps<T> = $props();
</script>

<svelte:element
	this={as}
	bind:this={ref}
	class={[avatarVariants({ radii, size }), className]}
	{...rest}
>
	{@render children?.()}
</svelte:element>
